/*
  Next.js statically exports the initial HTML, so components that must only
  render in the browser (for example, the cookie banner) need to wait for
  hydration to complete. Returning state set in useEffect (rather than
  checking `typeof window` during render) keeps the first client render
  identical to the server HTML and avoids hydration mismatches.
 */
import { useEffect, useState } from 'react'

export const useIsBrowser = () => {
  const [isBrowser, setIsBrowser] = useState(false)

  useEffect(() => {
    setIsBrowser(true)
  }, [])

  return isBrowser
}
